/**
 * md3cMarketingRouting.js — host check for the md3c.com public site.
 * Shaped by: md3c.com Step 2.
 * Invariants: only md3c.com, www.md3c.com, md3c-com.web.app, and
 * md3c-com.firebaseapp.com count. fusionmsi.com does not. Other subdomains
 * do not. localStorage MD3C_MARKETING_HOST=1 previews the host.
 * Related: src/routes/signedOutEntry.js,
 * src/features/clinicalHud/marketing/clinicalHudMarketingRouting.js.
 */

const HOST_PREVIEW_KEY = 'MD3C_MARKETING_HOST';

function matchesMd3cHostname(hostname) {
  const host = String(hostname || '').toLowerCase();
  return (
    host === 'md3c.com' ||
    host === 'www.md3c.com' ||
    host === 'md3c-com.web.app' ||
    host === 'md3c-com.firebaseapp.com'
  );
}

/**
 * True on the md3c.com marketing host.
 * An explicit hostname skips the preview key so a caller can name one host.
 * With no argument, localStorage MD3C_MARKETING_HOST=1 previews the host,
 * matching isClinicalHudMarketingHost.
 * @param {string} [hostname]
 * @returns {boolean}
 */
export function isMd3cMarketingHost(hostname) {
  if (typeof hostname === 'string') return matchesMd3cHostname(hostname);
  if (typeof window === 'undefined') return false;
  try {
    if (window.localStorage?.getItem(HOST_PREVIEW_KEY) === '1') return true;
  } catch {
    // localStorage may be unavailable (private mode).
  }
  return matchesMd3cHostname(window.location.hostname);
}
